import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=02001652&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('02001652', component.options)
    } else {
      api.reload('02001652', component.options)
    }
    module.hot.accept("./EditIcon.vue?vue&type=template&id=02001652&", function () {
      api.rerender('02001652', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/EditIcon.vue"
export default component.exports